export default __webpack_public_path__ + "static/media/upload.765e1d17.svg";